import * as React from 'react';

export type ColorPickerContextProps = {
    show: boolean;
    x: number;
    y: number;
    id: string;
    color: string;
    onClose?: () => void;
}

export type ColorPickerContextType = {
    props: ColorPickerContextProps,
    setProps: (props: ColorPickerContextProps) => void
}

export const ColorPickerContext = React.createContext(null);

export const ColorPickerProvider: React.FC = ({ children }) => {
    const [props, setProps] = React.useState<ColorPickerContextProps>({
        show: false,
        color: '#ffffff',
        x: 0,
        y: 0,
        id: '',
    });

    return (
        <ColorPickerContext.Provider value={{ props, setProps }}>
            {children}
        </ColorPickerContext.Provider>
    );
};
